export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7582.7cf7bb88.jpg";